module.exports = __webpack_public_path__ + "img/wire-2.ce346c60.jpg";